import { Container, Heading3, LazyRenderingButton } from "shared/components";
import { LazyRenderingProvider } from "shared/components/LazyRenderingButton";

import styles from "./Content051.module.scss";
import { Items } from "./Items";

export const Content051 = ({ payload }) => {
  const title = payload?.title ?? "";
  const partners = payload?.partners ?? [];

  return (
    <div className={styles.wrapper}>
      <Container>
        <div className={styles.block}>
          <Heading3 className={styles.title}>{title}</Heading3>

          <LazyRenderingProvider
            size={partners.length}
            initialLimit={8}
            incrementBy={8}
          >
            <Items items={partners} />
            <LazyRenderingButton />
          </LazyRenderingProvider>
        </div>
      </Container>
    </div>
  );
};

export default Content051;
